import React, { useState } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import axios from 'axios';

const GetDemoModal = ({ open, onCancel }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // Assuming there's a lead generation endpoint
      const response = await axios.post('/api/v1/leadGeneration', {
        ...values,
        source: 'Get a Demo Modal'
      });

      if (response.status === 200 || response.status === 201) {
        message.success('Request submitted successfully! We will contact you soon.');
        form.resetFields();
        onCancel();
      } else {
        message.error('Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting demo request:', error);
      message.error(error.response?.data?.message || 'Failed to submit request. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <div className="text-2xl font-bold text-jacarta-700 pt-4 px-4">
          Get a Free Demo
        </div>
      }
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={500}
      styles={{
        body: { padding: '24px 32px' }
      }}
    >
      <p className="text-jacarta-500 mb-6 px-4">
        Leave your details and we'll show you how SynthiaHire can transform your hiring process.
      </p>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        className="px-4"
      >
        <Form.Item
          name="name"
          label={<span className="font-semibold text-jacarta-700">Full Name</span>}
          rules={[{ required: true, message: 'Please enter your name' }]}
        >
          <Input placeholder="John Doe" size="large" className="rounded-lg" />
        </Form.Item>

        <Form.Item
          name="email"
          label={<span className="font-semibold text-jacarta-700">Corporate Email</span>}
          rules={[
            { required: true, message: 'Please enter your email' },
            { type: 'email', message: 'Please enter a valid email' }
          ]}
        >
          <Input placeholder="john@company.com" size="large" className="rounded-lg" />
        </Form.Item>

        <Form.Item
          name="company"
          label={<span className="font-semibold text-jacarta-700">Company Name</span>}
          rules={[{ required: true, message: 'Please enter your company name' }]}
        >
          <Input placeholder="Company Inc." size="large" className="rounded-lg" />
        </Form.Item>

        <Form.Item
          name="mobile"
          label={<span className="font-semibold text-jacarta-700">Phone Number</span>}
          rules={[
            { required: true, message: 'Please enter your phone number' },
            { pattern: /^[0-9+() -]{10,}$/, message: 'Please enter a valid phone number' }
          ]}
        >
          <Input placeholder="+1 234 567 890" size="large" className="rounded-lg" />
        </Form.Item>

        <Form.Item
          name="message"
          label={<span className="font-semibold text-jacarta-700">Additional Information</span>}
        >
          <Input.TextArea 
            placeholder="Tell us about your hiring needs..." 
            rows={4} 
            className="rounded-lg" 
          />
        </Form.Item>

        <Form.Item className="mb-0 pt-2">
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            className="w-full h-12 bg-accent hover:bg-accent-dark border-none rounded-xl text-lg font-bold transition-all"
          >
            Schedule Demo
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default GetDemoModal;
